import { Box } from '@warp-ds/react';
import React from 'react';
import { useSeoData } from '../../data/SeoData';
import { useFeatureToggles } from '../useFeatureToggles';

type CategoryDescriptionProps = {
    className?: string;
    resultsHeadingId: string;
};

export function CategoryDescription(props: CategoryDescriptionProps) {
    const { className, resultsHeadingId } = props;

    const { seoData } = useSeoData();
    const hasContent = seoData?.data.h1 || seoData?.data.category_text.html;

    const featureToggles = useFeatureToggles();
    const isEnabled = Boolean(featureToggles.seoApi);

    if (!hasContent || !isEnabled) {
        return null;
    }

    return (
        <Box className={className} neutral>
            <h1 className="h3" id={resultsHeadingId}>
                {seoData.data.h1}
            </h1>
            <div
                className="sf-seo-category-text"
                dangerouslySetInnerHTML={{
                    __html: seoData.data.category_text.html,
                }}
            />
        </Box>
    );
}
